import { DeleteOutlined } from '@ant-design/icons'
import { Button, Modal } from 'antd'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { NavigateFunction } from 'react-router-dom'

import { RouteEnum } from '../../../../constants/routes.enum'
import { useDeleteMilestone } from '../../../../entities/workflow/hooks/workflow.hooks'
import { MilestoneItem } from '../../../../entities/workflow/types/workflow.types'

export const getMilestoneTableColumns = (navigate: NavigateFunction) => {
  const { t } = useTranslation()
  const { mutateAsync: deleteMilestone } = useDeleteMilestone()

  return [
    {
      title: t('milestone.table.header'),
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: MilestoneItem) => (
        <span
          onClick={() => {
            navigate(`${RouteEnum.WORKSPACE}/${RouteEnum.MILESTONES}/${record.id}`)
          }}
          style={{ cursor: 'pointer', color: '#1890ff' }}
        >
          {text}
        </span>
      ),
    },
    {
      title: t('milestone.table.createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (date: string) => {
        return moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
    },
    {
      title: t('milestone.table.actions'),
      key: 'actions',
      width: '5%',
      render: (_: unknown, record: { id: number; name: string }) => (
        <Button
          color="danger"
          onClick={() => {
            Modal.confirm({
              title: t('milestone.deleteConfirmTitle'),
              content: `${record.name} ${t('milestone.deleteDescription')}`,
              onOk: () => {
                deleteMilestone(record.id)
              },
            })
          }}
          variant="text"
        >
          <DeleteOutlined />
        </Button>
      ),
    },
  ]
}
